document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-collection-tabs]').forEach(root=>{
    const buttons=[...root.querySelectorAll('[data-tab-button]')];
    const panels=[...root.querySelectorAll('[data-tab-panel]')];
    buttons.forEach(btn=>btn.addEventListener('click',()=>{
      const target=btn.dataset.tabButton;
      buttons.forEach(b=>b.setAttribute('aria-selected',String(b===btn)));
      panels.forEach(p=>p.classList.toggle('active',p.dataset.tabPanel===target));
    }));
  });
});

// Préremplit le modèle sur la page rendez-vous depuis la fiche produit.
document.addEventListener('DOMContentLoaded', function () {
  var field = document.getElementById('ContactProduct');
  if (!field) return;
  var params = new URLSearchParams(window.location.search);
  var productName = params.get('produit');
  if (productName && !field.value) field.value = productName;
});
